import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { MyTranslationSetFragmentDoc, CoverImageFragmentDoc } from '../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyCompletedTrainingTableQueryVariables = Types.Exact<{
  input: Types.AssignmentsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type MyCompletedTrainingTableQuery = { __typename?: 'Query', Assignments: { __typename?: 'Assignments', totalCount: number, objects: Array<{ __typename?: 'Assignment', id: string, status: AssignmentStatus, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null }, currentCourseInstance?: { __typename?: 'CourseInstance', id: number, completedAt?: string | null } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, completedAt?: string | null } | null, currentSCORMCourseInstance?: { __typename?: 'SCORMCourseInstance', id: string, completedAt?: string | null } | null }> } };

export type MyCompletedTrainingTable_AssignmentFragment = { __typename?: 'Assignment', id: string, status: AssignmentStatus, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null }, currentCourseInstance?: { __typename?: 'CourseInstance', id: number, completedAt?: string | null } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, completedAt?: string | null } | null, currentSCORMCourseInstance?: { __typename?: 'SCORMCourseInstance', id: string, completedAt?: string | null } | null };

export type MyCompletedTrainingTable_LibraryItemFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null };

export type MyCompletedTrainingTable_ModuleInstanceFragment = { __typename?: 'ModuleInstance', id: string, completedAt?: string | null };

export type MyCompletedTrainingTable_CourseInstanceFragment = { __typename?: 'CourseInstance', id: number, completedAt?: string | null };

export type MyCompletedTrainingTable_ScormCourseInstanceFragment = { __typename?: 'SCORMCourseInstance', id: string, completedAt?: string | null };

export const MyCompletedTrainingTable_LibraryItemFragmentDoc = gql`
    fragment MyCompletedTrainingTable_LibraryItem on LibraryItem {
  id
  type
  name {
    ...MyTranslationSet
  }
  coverImage {
    ...CoverImage
  }
}
    ${MyTranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const MyCompletedTrainingTable_CourseInstanceFragmentDoc = gql`
    fragment MyCompletedTrainingTable_CourseInstance on CourseInstance {
  id
  completedAt
}
    `;
export const MyCompletedTrainingTable_ModuleInstanceFragmentDoc = gql`
    fragment MyCompletedTrainingTable_ModuleInstance on ModuleInstance {
  id
  completedAt
}
    `;
export const MyCompletedTrainingTable_ScormCourseInstanceFragmentDoc = gql`
    fragment MyCompletedTrainingTable_SCORMCourseInstance on SCORMCourseInstance {
  id
  completedAt
}
    `;
export const MyCompletedTrainingTable_AssignmentFragmentDoc = gql`
    fragment MyCompletedTrainingTable_Assignment on Assignment {
  id
  status
  libraryItem {
    ...MyCompletedTrainingTable_LibraryItem
  }
  currentCourseInstance {
    ...MyCompletedTrainingTable_CourseInstance
  }
  currentModuleInstance {
    ...MyCompletedTrainingTable_ModuleInstance
  }
  currentSCORMCourseInstance {
    ...MyCompletedTrainingTable_SCORMCourseInstance
  }
}
    ${MyCompletedTrainingTable_LibraryItemFragmentDoc}
${MyCompletedTrainingTable_CourseInstanceFragmentDoc}
${MyCompletedTrainingTable_ModuleInstanceFragmentDoc}
${MyCompletedTrainingTable_ScormCourseInstanceFragmentDoc}`;
export const MyCompletedTrainingTableDocument = gql`
    query MyCompletedTrainingTable($input: AssignmentsInput!, $pagination: PaginationInput) {
  Assignments(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...MyCompletedTrainingTable_Assignment
    }
  }
}
    ${MyCompletedTrainingTable_AssignmentFragmentDoc}`;

/**
 * __useMyCompletedTrainingTableQuery__
 *
 * To run a query within a React component, call `useMyCompletedTrainingTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCompletedTrainingTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCompletedTrainingTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMyCompletedTrainingTableQuery(baseOptions: Apollo.QueryHookOptions<MyCompletedTrainingTableQuery, MyCompletedTrainingTableQueryVariables> & ({ variables: MyCompletedTrainingTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCompletedTrainingTableQuery, MyCompletedTrainingTableQueryVariables>(MyCompletedTrainingTableDocument, options);
      }
export function useMyCompletedTrainingTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCompletedTrainingTableQuery, MyCompletedTrainingTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCompletedTrainingTableQuery, MyCompletedTrainingTableQueryVariables>(MyCompletedTrainingTableDocument, options);
        }
export type MyCompletedTrainingTableQueryHookResult = ReturnType<typeof useMyCompletedTrainingTableQuery>;
export type MyCompletedTrainingTableLazyQueryHookResult = ReturnType<typeof useMyCompletedTrainingTableLazyQuery>;
export type MyCompletedTrainingTableQueryResult = Apollo.QueryResult<MyCompletedTrainingTableQuery, MyCompletedTrainingTableQueryVariables>;